module.exports = __webpack_public_path__ + "img/three-iphones-tablet@2x.04e67c19.png";